/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_IntroInputs */

const en_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited spots. Register online to reserve your place.`)
};

const es_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupos limitados. Regístrate en línea para reservar tu lugar.`)
};

const de_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenzte Plätze. Registrieren Sie sich online, um Ihren Platz zu reservieren.`)
};

const zh_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名额有限。在线注册以保留你的位置。`)
};

const ar_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقاعد محدودة. سجّل عبر الإنترنت لحجز مكانك.`)
};

const fr_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places limitées. Inscrivez-vous en ligne pour réserver votre place.`)
};

const vi_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số chỗ có hạn. Đăng ký trực tuyến để giữ chỗ.`)
};

const sw_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi ni chache. Jisajili mtandaoni ili kuweka nafasi yako.`)
};

const th_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่นั่งมีจำนวนจำกัด ลงทะเบียนออนไลน์เพื่อสำรองที่นั่งของคุณ`)
};

const bs_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograničen broj mjesta. Registrujte se online da rezervišete mjesto.`)
};

const ja_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定員に限りがあります。オンラインで登録して参加枠を確保してください。`)
};

const ko_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자리가 한정되어 있습니다. 온라인으로 등록해 자리를 예약하세요.`)
};

const pt_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vagas limitadas. Inscreva-se online para garantir seu lugar.`)
};

const it_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posti limitati. Registrati online per prenotare il tuo posto.`)
};

const sv_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begränsade platser. Registrera dig online för att reservera din plats.`)
};

const nl_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beperkt aantal plaatsen. Schrijf je online in om je plek te reserveren.`)
};

const da_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrænset antal pladser. Tilmeld dig online for at sikre din plads.`)
};

const nb_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenset antall plasser. Meld deg på på nett for å sikre plassen din.`)
};

const fi_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paikkoja on rajoitetusti. Ilmoittaudu verkossa varataksesi paikkasi.`)
};

const pl_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczone miejsca. Zarejestruj się online, aby zarezerwować swoje miejsce.`)
};

const ru_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченные места. Зарегистрируйтесь онлайн, чтобы забронировать место.`)
};

const tr_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontenjan sınırlı. Yerinizi ayırtmak için online kayıt olun.`)
};

const hi_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीमित स्थान। अपना स्थान सुरक्षित करने के लिए ऑनलाइन पंजीकरण करें।`)
};

const id_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat terbatas. Daftar secara online untuk memesan tempat Anda.`)
};

const ms_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat terhad. Daftar dalam talian untuk menempah tempat anda.`)
};

const cs_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omezený počet míst. Zaregistrujte se online a zajistěte si místo.`)
};

const el_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Περιορισμένες θέσεις. Εγγραφείτε online για να εξασφαλίσετε τη θέση σας.`)
};

const he_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר המקומות מוגבל. הירשמו אונליין כדי לשמור את המקום שלכם.`)
};

const af_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beperkte plekke. Registreer aanlyn om jou plek te bespreek.`)
};

const hu_events_intro = /** @type {(inputs: Events_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korlátozott számú hely. Regisztrálj online, hogy biztosítsd a helyed.`)
};

/**
* | output |
* | --- |
* | "Limited spots. Register online to reserve your place." |
*
* @param {Events_IntroInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_intro = /** @type {((inputs?: Events_IntroInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_IntroInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_intro(inputs)
	if (locale === "de") return de_events_intro(inputs)
	if (locale === "zh") return zh_events_intro(inputs)
	if (locale === "ar") return ar_events_intro(inputs)
	if (locale === "fr") return fr_events_intro(inputs)
	if (locale === "vi") return vi_events_intro(inputs)
	if (locale === "sw") return sw_events_intro(inputs)
	if (locale === "th") return th_events_intro(inputs)
	if (locale === "bs") return bs_events_intro(inputs)
	if (locale === "ja") return ja_events_intro(inputs)
	if (locale === "ko") return ko_events_intro(inputs)
	if (locale === "pt") return pt_events_intro(inputs)
	if (locale === "it") return it_events_intro(inputs)
	if (locale === "sv") return sv_events_intro(inputs)
	if (locale === "nl") return nl_events_intro(inputs)
	if (locale === "da") return da_events_intro(inputs)
	if (locale === "nb") return nb_events_intro(inputs)
	if (locale === "fi") return fi_events_intro(inputs)
	if (locale === "pl") return pl_events_intro(inputs)
	if (locale === "ru") return ru_events_intro(inputs)
	if (locale === "tr") return tr_events_intro(inputs)
	if (locale === "hi") return hi_events_intro(inputs)
	if (locale === "id") return id_events_intro(inputs)
	if (locale === "ms") return ms_events_intro(inputs)
	if (locale === "cs") return cs_events_intro(inputs)
	if (locale === "el") return el_events_intro(inputs)
	if (locale === "he") return he_events_intro(inputs)
	if (locale === "af") return af_events_intro(inputs)
	if (locale === "hu") return hu_events_intro(inputs)
	return en_events_intro(inputs)
});